import { Tooltip, styled } from "@mui/material";
import { actionBarName } from "../classes.js";
const MenuTooltip = styled(Tooltip, {
  name: actionBarName,
  slot: "MenuTooltip",
  overridesResolver: (_props, styles) => styles.menuTooltip
})``;
export {
  MenuTooltip
};
//# sourceMappingURL=MenuTooltip.js.map
